export default {
  independentMarketing: {
    common: {
      requestFailed: 'Yêu cầu giao diện không thành công',
      hintSelect: 'Lựa chọn',
      hintInput: 'Đi vào',
      submit: 'Nộp',
      cancel: 'Hủy bỏ',
      confirm: 'ĐƯỢC RỒI',
    },
    agreement: {
      title: 'Thỏa thuận đăng ký đại lý độc lập Autel',
      nextBtn: 'Tiếp theo',
      getAgreementFailed: 'Không thể tải được nội dung thỏa thuận.',
    },
    successPage: {
      title:
        'Thông tin đơn đăng ký của bạn đã được gửi thành công và kết quả xem xét sẽ được gửi đến email của bạn $1 trong vòng 15 ngày làm việc. Vui lòng kiểm tra hộp thư đến của bạn để biết thêm thông tin.',
      subTitle: 'Trở về trang chủ sau $1 giây.',
    },
    applyTitle: 'Bạn đang đăng ký để trở thành đại lý độc lập của Autel. Vui lòng điền chính xác các thông tin sau:',
    companyName: 'Tên công ty',
    companyTax: 'VAT ID',
    userCountry: 'Quốc gia',
    legalPerson: 'Tư vấn pháp lý',
    contactEmail: 'Địa chỉ email liên lạc',
    contactEmailTips:
      'Địa chỉ email này sẽ là email liên hệ của bạn về kết quả đánh giá. Sau khi đánh giá được phê duyệt, nó cũng sẽ được sử dụng làm tên tài khoản đăng nhập cho hệ thống quản lý đại lý độc lập.',
    corporateIdentity: 'ID cố vấn pháp lý',
    uploadTips: 'JPG, JPEG, PNG, PDF (không lớn hơn 20 MB)',
    businessLicense: 'Giấy phép kinh doanh',
    emailErrorTips: 'Nhập email hợp lệ.',
    uploadPic: 'Đăng tải hình ảnh',
    picMaxLimit: 'Kích thước hình ảnh tối đa là 20 MB. Vui lòng chọn lại.',
  },
};
